import { useQueryClient, useSuspenseQuery } from "@tanstack/react-query";
import { useSearchValuesState2 } from "globalStates/cardSearchValuesState";
import { apiFetchUser, apiPatchUser, apiUploadUserAvatar } from "modules/Drupal/Drupal";
import { TCard } from "./CardModel";
import { TRoute } from "./RouteModel";

type TUser = {
  uid: number;
  menus: [];
  routes: TRoute[];
  cards: [];
  layouts: {};
  firstName: string;
  lastName: string;
  shitenCD: string;
  avatar_file_id: number;
  avatar_url: string;
  availableFunctions: string[];
} | null;

const useUser = () => {
  const { data: fetchedUserData, refetch } = useSuspenseQuery({
    queryKey: ["userData"],
    queryFn: apiFetchUser,
  });

  const getUser = () => (fetchedUserData?.status === "success" ? fetchedUserData.user : null);
  const user = fetchedUserData?.status === "success" ? fetchedUserData.user : null;
  const { getAllSearchValues } = useSearchValuesState2();

  const patchUser = async (data: any) => {
    const newData = { ...data };
    const routeIds = newData.routes ? newData.routes.map((r: TRoute) => r.id) : user?.routes.map((r) => r.id);
    if (newData.cards) {
      const allSearchValues = await getAllSearchValues();
      newData.cards = newData.cards
        .filter((card: TCard) => routeIds?.includes(card.route_id))
        .map(({ ...card }: TCard) => {
          const searchValues = allSearchValues.find((vals) => vals && vals.cardId === card.uuid);
          card.search_values = searchValues ? searchValues.values : {};
          return card;
        });
    }
    if (newData.layouts) {
      newData.layouts = newData.layouts.filter((l: any) => routeIds?.includes(l.route_id));
    }

    const result = await apiPatchUser(fetchedUserData?.raw, newData);
    return result;
  };

  const uploadUserAvatar = async (file: File) => {
    const result: any = await apiUploadUserAvatar(file);
    return result;
  };

  return { user, getUser, patchUser, refetchUser: refetch, uploadUserAvatar };
};

const useResetUser = () => {
  const queryClient = useQueryClient();
  const resetUser = () => {
    queryClient.clear();
  };
  return resetUser;
};

export type { TUser };

export { useUser, useResetUser };
